import React from 'react';
import { useParams } from 'react-router-dom';
import AdminDetailHostingComponent from "../../../components/Admin/hostings/AdminDetailHostingComponent";

const AdminDetailHostingPage = () => {
    const params = useParams()
    return <AdminDetailHostingComponent hostingId={ params.hostingId } />;
}

export default AdminDetailHostingPage;